// TODO: Remove once BE is fixed.
//       Otherwise we need to hardcode these every year and for every single
//       Package for all customers that are active.

const lakefrontMusicFest = ticketTypeId => {
  // Lakefront Music Fest
  if (ticketTypeId === 35951) {
    return 26886; // Saturday 2025
  } else if (ticketTypeId === 35928) {
    return 26881; // Friday 2025
  }
  // send warning to Sentry?
  return undefined;
};

const prideBlockParty = ticketTypeId => {
  // Pride Block Party
  if (ticketTypeId === 36951) {
    // GA Weekend Pass Fri
    return 27270; // Friday 2025
  } else if (ticketTypeId === 36956) {
    // GA Weekend Pass - Sat
    return 27271; // Saturday 2025
  } else if (ticketTypeId === 36961) {
    // GA Weekend Pass - Sun
    return 27272; // Sunday 2025
  }
};

export const getPackage2025DateID = ticketTypeId => {
  const dateID = prideBlockParty(ticketTypeId);
  if (typeof dateID === "number") return dateID;
  return lakefrontMusicFest(ticketTypeId);
};
